import React, { useState } from 'react';
import SignupForm from '../components/SignupForm';

export default function SignupPage({ onSignup }) {
  const [success, setSuccess] = useState(false);

  const handleSignupSuccess = (userData) => {
    setSuccess(true);
    if (onSignup) {
      onSignup(userData);
    }
  };

  return (
    <div className="d-flex align-center justify-center" style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%)',
      padding: 'var(--spacing-4)'
    }}>
      <div className="card" style={{ maxWidth: '480px', width: '100%' }}>
        <div className="card__header text-center" style={{ 
          background: 'linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%)',
          color: 'white'
        }}>
          <h1 style={{ margin: 0, fontSize: 'var(--font-size-3xl)' }}>Join GradedWash</h1>
          <p style={{ 
            margin: 'var(--spacing-2) 0 0 0', 
            color: 'white',
            fontWeight: '500',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
          }}>
            Find your perfect travel companion based on personality compatibility
          </p>
        </div>
        
        {success ? (
          <div className="card__body text-center">
            <div className="bg-success text-white" style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 'var(--font-size-2xl)',
              fontWeight: 'bold',
              margin: '0 auto var(--spacing-5)'
            }}>
              ✓
            </div>
            <h2>Welcome to GradedWash!</h2>
            <p className="text-muted">
              Your account has been created successfully. You can now log in and start connecting with like-minded travelers.
            </p>
            <a href="/login" className="btn btn--primary">Go to Login</a>
          </div>
        ) : (
          <>
            <div className="card__body">
              <SignupForm onSuccess={handleSignupSuccess} />
            </div>
            <div className="card__footer text-center">
              <p style={{ margin: 0, fontSize: 'var(--font-size-sm)' }}>
                Already have an account? <a href="/login" className="text-primary">Sign in here</a>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

